/**
 * @file コンポーネント：フル動画ページ症例タグリスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// 関数読み込み
import { fnGetDepartmentPathname } from "~/src/functions/common";

// スタイル読み込み
import {
    StyledContent,
    StyledContentEdit,
    StyledContentEditAnchor,
    StyledContentEditAnchorIcon,
    StyledContentEditAnchorText,
    StyledContentParagragh,
    StyledContentTaglist,
    StyledContentTaglistItem,
    StyledContentTaglistItemAnchor,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledContent>
            {props.taglist.length > 0 ? (
                // タグの登録がある場合
                <StyledContentTaglist>
                    {props.taglist.map((tag, index) => (
                        <StyledContentTaglistItem key={"tag-" + index}>
                            <StyledContentTaglistItemAnchor
                                href={
                                    fnGetDepartmentPathname() +
                                    "/search?tag=" +
                                    tag.id
                                }
                            >
                                {tag.name}
                            </StyledContentTaglistItemAnchor>
                        </StyledContentTaglistItem>
                    ))}
                </StyledContentTaglist>
            ) : (
                // タグの登録がない場合
                <StyledContentParagragh>
                    {localized["Label.NoTags"]}
                </StyledContentParagragh>
            )}
            {props.isEditPage === true && (
                // 執刀医権限フル動画ページの場合
                <StyledContentEdit>
                    <StyledContentEditAnchor
                        href="#"
                        onClick={(e) =>
                            props.fnSetModalEdit(e, "taglist", "edit", {
                                list: props.taglist,
                            })
                        }
                    >
                        <StyledContentEditAnchorIcon>
                            <i className="fas fa-edit"></i>
                        </StyledContentEditAnchorIcon>
                        <StyledContentEditAnchorText>
                            {localized["Label.Edit"]}
                        </StyledContentEditAnchorText>
                    </StyledContentEditAnchor>
                </StyledContentEdit>
            )}
        </StyledContent>
    );
};
